import http from "./httpService";

const apiEndPoint = "/keyaccountpresettings/";

export function getKeyAccountPresettings() {
  return http.get(apiEndPoint);
}

export function updateKeyAccountPresetting(id, payload) {
  return http.patch(`${apiEndPoint}${id}/`, payload);
}

export function toggleStoreKeyAccount(storeId, isKeyAccount) {
  return http.post(`/stores/${storeId}/key-account-toggle/`, {
    is_key_account: isKeyAccount,
  });
}

export function getKeyAccountManagers() {
  return http.get("/keyaccountpresettings/managers/");
}

export function searchUsersForKeyAccountToggle(query) {
  return http.get("/keyaccountpresettings/managers/", { params: { search: query } });
}

export function grantKeyAccountTogglePermission(userId) {
  return http.post("/keyaccountpresettings/managers/", { user_id: userId });
}

export function revokeKeyAccountTogglePermission(userId) {
  return http.delete(`/keyaccountpresettings/managers/${userId}/`);
}
